module.exports = __webpack_public_path__ + "img/img02.916c79a7.svg";